/**
 * Category Group API Service
 * Handles all category group-related API calls
 */
import apiService from './apiService';

class CategoryGroupService {
  /**
   * Endpoint base path
   */
  basePath = '/api/categorygroup';
  
  /**
   * Get all category groups with optional filters
   * @param {Object} params - Filter parameters
   * @param {string} [params.Name] - The name of the category group to filter by (partial match)
   * @param {string} [params.Description] - The description of the category group to filter by (partial match)
   * @param {number} [params.ExamTypeId] - The exam type ID to filter by
   * @param {boolean} [params.Enabled] - Filter by enabled/disabled status
   * @returns {Promise<Array>} - Array of category groups
   */
  async getCategoryGroups(params = {}) {
    return apiService.get(this.basePath, params);
  }
  
  /**
   * Get a specific category group by ID
   * @param {number} id - The ID of the category group to retrieve
   * @returns {Promise<Object>} - The category group details
   */
  async getCategoryGroupById(id) {
    return apiService.get(`${this.basePath}/${id}`);
  }
  
  /**
   * Get category groups by exam type ID
   * @param {number} examTypeId - The exam type ID to filter by
   * @returns {Promise<Array>} - Array of category groups for the specified exam type
   */
  async getCategoryGroupsByExamTypeId(examTypeId) {
    return this.getCategoryGroups({ ExamTypeId: examTypeId });
  }
}

// Export singleton instance
export default new CategoryGroupService();
